import { ChangeDetectionStrategy, Component, inject, signal, viewChild } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { Router, RouterLink } from '@angular/router';

import { CxMenuModule } from '@bbraun/cortex/carousel';
import { CwActionIcon, CwDivider, CwSpinner, CwTooltip } from '@bbraun/cortex-angular';
import { TranslocoDirective } from '@jsverse/transloco';

import { ROUTES } from '../../../definitions/constants/routes.constants';
import { LayoutStoreFacade } from '../../../stores/global-store/layout/layout-store.facade';
import { UserConfigsStoreFacade } from '../../../stores/global-store/user-configs/user-configs-store.facade';
import { NotificationsStoreService } from '../../../stores/signal-stores/notifications-store/notifications-store.service';
import { NotificationRowComponent } from '../notifications/notification-row/notification-row.component';

@Component({
  selector: 'app-header-notifications',
  imports: [
    MatIcon,
    MatIconButton,
    MatMenuTrigger,
    MatMenu,
    CxMenuModule,
    TranslocoDirective,
    CwSpinner,
    NotificationRowComponent,
    CwActionIcon,
    RouterLink,
    CwTooltip,
    CwDivider
  ],
  templateUrl: './header-notifications.component.html',
  styleUrl: './header-notifications.component.sass',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderNotificationsComponent {
  protected readonly notificationMenuTrigger = viewChild<MatMenuTrigger>('notificationMenuTrigger');
  protected readonly notificationsRoute = [ '/', ROUTES.REPLENISHMENT, ROUTES.NOTIFICATIONS ];
  protected readonly notificationsSettingsRoute = [ '/', ROUTES.REPLENISHMENT, ROUTES.NOTIFICATIONS_SETTINGS ];

  public isNotificationDropdownOpen = signal<boolean>(false);

  public readonly notificationsState = inject(NotificationsStoreService);
  public readonly userConfigsFacade = inject(UserConfigsStoreFacade);
  public readonly layoutFacade = inject(LayoutStoreFacade);
  private readonly router = inject(Router);

  public onMenuChange(isMenuOpened: boolean): void {
    this.isNotificationDropdownOpen.set(isMenuOpened);
    if (isMenuOpened) {
      this.notificationsState.loadNotifications();
    }
  }

  public onMarkAllAsReadClicked(): void {
    this.notificationsState.markAllAsRead();
  }

  public onViewAllNotificationsClick(): void {
    if (this.notificationMenuTrigger()) {
      this.notificationMenuTrigger()!.closeMenu();
    }
    this.router.navigate(this.notificationsRoute);
  }

  protected readonly ROUTES = ROUTES;
}
